import { useI18n } from "@/lib/i18n";

const NL = [
  ["1. Wie we zijn", "Peptivance verwerkt persoonsgegevens die je aan ons verstrekt bij het plaatsen van een bestelling of het invullen van het contactformulier. Verantwoordelijke: Peptivance, e-mail: hello@peptivance.eu."],
  ["2. Welke gegevens verzamelen we", "Naam, e-mailadres, verzendadres, IP-adres en aankoophistorie. Betaalgegevens worden verwerkt door Stripe en raken onze servers niet."],
  ["3. Waarom we gegevens verwerken", "Voor het uitvoeren van je bestelling, het versturen van orderbevestigingen, klantcommunicatie en het voldoen aan wettelijke bewaarplichten (fiscaal 7 jaar)."],
  ["4. Rechtsgrondslag", "Uitvoering van de koopovereenkomst (Art. 6.1.b AVG), wettelijke plicht (Art. 6.1.c AVG) en gerechtvaardigd belang voor fraudepreventie."],
  ["5. Delen met derden", "We delen gegevens alleen met: Stripe (betalingsverwerking), PostNL/DHL (verzending) en onze e-mailprovider Resend (transactionele e-mail). Nooit voor marketing van derden."],
  ["6. Bewaartermijn", "Bestelgegevens worden 7 jaar bewaard (fiscale plicht). Contactformulier-berichten worden na 2 jaar verwijderd. Nieuwsbrief-inschrijvingen tot uitschrijving."],
  ["7. Jouw rechten", "Je hebt recht op inzage, correctie, verwijdering en dataportabiliteit van je gegevens. Neem contact op via hello@peptivance.eu. We reageren binnen 30 dagen."],
  ["8. Cookies", "We gebruiken alleen strikt noodzakelijke cookies (winkelmand, taalvoorkeur, JWT-token). Geen tracking cookies of advertentiecookies."],
];

const EN = [
  ["1. Who we are", "Peptivance processes personal data you provide when placing an order or filling in the contact form. Controller: Peptivance, email: hello@peptivance.eu."],
  ["2. Data we collect", "Name, email, shipping address, IP address and purchase history. Payment data is processed by Stripe and does not touch our servers."],
  ["3. Why we process", "To fulfill your order, send order confirmations, customer communication, and comply with legal retention obligations (tax 7 years)."],
  ["4. Legal basis", "Performance of purchase agreement (Art. 6.1.b GDPR), legal obligation (Art. 6.1.c GDPR) and legitimate interest for fraud prevention."],
  ["5. Third parties", "We share data only with: Stripe (payment), PostNL/DHL (shipping) and our email provider Resend (transactional email). Never for third-party marketing."],
  ["6. Retention", "Order data is kept for 7 years (tax obligation). Contact form messages are deleted after 2 years. Newsletter subscriptions until unsubscribe."],
  ["7. Your rights", "You have the right to access, correct, delete and port your data. Contact us at hello@peptivance.eu. We respond within 30 days."],
  ["8. Cookies", "We use only strictly necessary cookies (cart, language preference, JWT token). No tracking or advertising cookies."],
];

export default function Privacy() {
  const { lang } = useI18n();
  const items = lang === "nl" ? NL : EN;
  return (
    <div data-testid="privacy-page" className="pt-32 pb-24 bg-[#F7F7F6] min-h-screen">
      <div className="max-w-[1000px] mx-auto px-6 md:px-12">
        <p className="font-mono-label text-[11px] text-neutral-500 mb-8">[ LEGAL / PRIVACY ]</p>
        <h1 className="font-serif-display font-light text-5xl md:text-7xl leading-[0.98] mb-16">
          {lang === "nl" ? "Privacyverklaring" : "Privacy statement"}
        </h1>
        <div className="border-t border-neutral-300">
          {items.map(([title, body], i) => (
            <div key={i} className="border-b border-neutral-300 py-10 grid md:grid-cols-12 gap-8">
              <div className="md:col-span-1 font-mono-label text-[10px] text-neutral-500">0{i + 1}</div>
              <div className="md:col-span-4">
                <h2 className="font-serif-display text-2xl md:text-3xl leading-tight">{title}</h2>
              </div>
              <div className="md:col-span-7">
                <p className="text-neutral-600 leading-relaxed">{body}</p>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-16 font-mono-label text-[10px] text-neutral-500">
          Last updated: {new Date().toLocaleDateString(lang === "nl" ? "nl-NL" : "en-GB")}
        </p>
      </div>
    </div>
  );
}
